import Swiper from 'swiper/dist/js/swiper.js';
const $header = $('.header');
require('./content-slider.js');
require('./gallery-slider.js');
const verge = require('verge');
window.verge = verge;

const breakpoint = window.matchMedia('(max-width:1024px), (max-height: 860px)');
let mainSwiper;

if ($('.swiper-container--main').length) {
    const breakpointChecker = function() {
        if (breakpoint.matches === true) {
            if (mainSwiper !== undefined && mainSwiper.destroyed !== true) {
                mainSwiper.destroy(true, true);
                $header.removeClass('header--dark');
                $header.addClass('substrate');
            } else {
                $header.addClass('substrate');
            }
            return;
        } else if (breakpoint.matches === false) {
            return enableSwiper();
        }
    };

    const enableSwiper = function() {
        mainSwiper = new Swiper('.swiper-container--main', {
            spaceBetween: 0,
            loop: false,
            speed: 900,
            direction: 'vertical',
            simulateTouch: false,
            init: false,
            hashNavigation: true,
            keyboard: {
                enabled: true,
                onlyInViewport: false
            },
            mousewheel: true,
            pagination: {
                el: '.swiper-pagination--main',
                clickable: false,
                type: 'bullets',
                renderBullet: function(index, className) {
                    let $slide = $(this.slides[index]);
                    return `
                        <div class="${className}">
                            <span class="${className}__title"></span>
                        </div>`;
                }
            },
            navigation: {
                nextEl: '.swiper-navigation__next',
                prevEl: '.swiper-navigation__prev'
            },
            on: {
                beforeDestroy: function() {}
            }
        });
        mainSwiper.on('init', function() {
            let $slide1 = $(mainSwiper.slides[0]);
            let $slide3 = $(mainSwiper.slides[2]);

            $(
                '.swiper-container--main > .swiper-pagination--main, .swiper-container--main > .swiper-navigation--main'
            ).css({
                left: `${$('.logo').offset().left}px`,
                top: `${$header.outerHeight()}px`
            });

            $(window).on('resize', function() {
                $(
                    '.swiper-container--main > .swiper-pagination--main, .swiper-container--main > .swiper-navigation--main'
                ).css({
                    left: `${$('.logo').offset().left}px`,
                    top: `${$header.outerHeight()}px`
                });
            });

            $('.swiper-preloader').velocity('transition.fadeOut', {
                delay: 1000
            });
            $('.body--index .decorate-column').velocity(
                {
                    opacity: 1
                },
                {
                    delay: 300
                }
            );
        });
        mainSwiper.on('slideChangeTransitionStart', function() {
            initSlideLogic(mainSwiper.activeIndex);
        });
        mainSwiper.init();

        $header.removeClass('substrate');

        function initSlideLogic(index) {
            let $slide = $(mainSwiper.slides[index]);
            switch (index) {
                case 0:
                    $header.removeClass('header--dark');
                    $('.swiper-pagination--main').removeClass(
                        'swiper-pagination--dark'
                    );
                    $('.swiper-navigation--main').removeClass(
                        'swiper-navigation--dark'
                    );
                    break;

                case 1:
                    if (mainSwiper !== undefined) {
                        $header.addClass('header--dark');
                    }
                    $('.swiper-pagination--main').addClass(
                        'swiper-pagination--dark'
                    );
                    $('.swiper-navigation--main').addClass(
                        'swiper-navigation--dark'
                    );
                    break;

                case 2:
                    $header.removeClass('header--dark');
                    $('.swiper-pagination--main').removeClass(
                        'swiper-pagination--dark'
                    );
                    $('.swiper-navigation--main').removeClass(
                        'swiper-navigation--dark'
                    );
                    break;
            }
        }
    };

    function checkHeaderScrollMobile() {
        if (
            verge.scrollY($('.slide--2')) - $('.slide--1').outerHeight() >= 0 &&
            verge.scrollY($('.slide--3')) -
                $('.slide--1').outerHeight() -
                $('.slide--2').outerHeight() <
                0
        ) {
            if (mainSwiper !== undefined && mainSwiper.destroyed !== true) {
                $header.addClass('header--dark');
            }
        } else {
            $header.removeClass('header--dark');
        }
    }

    $(window).scroll(function() {
        checkHeaderScrollMobile();
        // if (verge.viewportW() <= 1024) {
        // }
    });

    breakpoint.addListener(breakpointChecker);
    breakpointChecker();

    // Horizontal slider
    const mainHorizontalSwiper = new Swiper(`.swiper-container--main-horizontal`, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        speed: 900,
        effect: 'fade',
        // autoHeight: true,
        simulateTouch: false,
        init: false,
        mousewheel: false,
        pagination: {
            el: `.swiper-pagination--main-horizontal`,
            clickable: true,
            type: 'bullets',
            renderBullet: function (index, className) {
                const $slide = $(this.slides[index + 1]);
                const title = $slide.data('title');

                return `
                    <div class="${className}">
                        <span class="${className}__title">${title}</span>
                    </div>`;
            },
        },
        autoplay: {
            delay: 10000
        }
    });

    // Horizontal slider custom controls
    mainHorizontalSwiper.on('init', function () {
        if ($('.swiper-container--main > .swiper-wrapper > .slide .swiper-controls').length) {
            setTimeout(function () {
                let offsetBottom =
                    $(window).outerHeight() -
                    $('.swiper-container--main > .swiper-wrapper > .slide .swiper-controls').offset().top;
                $('.swiper-container--main > .swiper-wrapper > .slide .slide').css({
                    'padding-bottom': `${offsetBottom}px`
                });
            }, 100);
        }
    });

    // Horizontal slider init
    mainHorizontalSwiper.init();
}

// TEAM SLIDER MAINPAGE
const teamSwiper = new Swiper('.swiper-container--team:not(.team)', {
    spaceBetween: 22,
    slidesPerView: 2,
    scrollbar: {
        el: '.swiper-scrollbar--team',
        hide: false
    },
    navigation: {
        nextEl: '.swiper-button-next--team',
        prevEl: '.swiper-button-prev--team'
    },
    breakpoints: {
        520: {
            slidesPerView: 1
        },
        768: {
            slidesPerView: 2
        },
        1024: {
            slidesPerView: 1
        }
    }
});

// TEAM SLIDER MAINPAGE
if ($('.team-slider').length) {
    let hashSlide = 0;

    if (location.hash.length) {
        let hash = location.hash,
            arIds = $('.team-content')
                .find('.swiper-slide')
                .map(function() {
                    return $(this).attr('data-id');
                });

        hashSlide = arIds.toArray().indexOf(hash);

        if (hashSlide < 0) {
            hashSlide = 0;
        }
    }

    const galleryThumbs = new Swiper('.team-thumbs', {
        spaceBetween: 22,
        slidesPerView: 3,
        init: false,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        breakpoints: {
            520: {
                slidesPerView: 1
            },
            768: {
                slidesPerView: 2
            },
            1024: {
                slidesPerView: 3
            }
        },
    });

    galleryThumbs.on('init', function() {
        const galleryTop = new Swiper('.team-content', {
            spaceBetween: 0,
            autoHeight: true,
            init: false,
            initialSlide: hashSlide,
            simulateTouch: false,
            navigation: {
                nextEl: '.swiper-button-next--team',
                prevEl: '.swiper-button-prev--team'
            },
            on: {
                slideChange: function() {
                    location.hash = $(this.slides[this.activeIndex]).attr(
                        'data-id'
                    );
                }
            },
            thumbs: {
                swiper: galleryThumbs
            }
        });

        galleryThumbs.on('slideChange', function() {
            if (verge.viewportW() <= 520) {
                galleryTop.slideTo(galleryThumbs.activeIndex);
            }
        });
        galleryTop.init();
    });

    galleryThumbs.init();
}



// WEBPACK FOOTER //
// ./frontend/components/slider/slider.js